import React from 'react';
import PlanActions from '../MyPlans/PlanActions';
import { handleDownload, camelize, dateConvert } from './../../utils/Common.js';

const PlanCard = (plan) => {
    console.log("PlanPlanCard",plan?.userId);
    console.log("PlanPlanCardplan",plan);
    // console.log("userIduserId",userId);
  return (
    <div className="plan-card">
        <div className="plan-details">
            <div className='row-1 head'>
                <span className='plan-name'>{plan?.plan?.plan?.plan_description || ''}</span>
                {plan?.plan?.is_expired
                    ? <p className="expired">Expired</p>
                    : <p className="active">{camelize(plan?.plan?.status || '')}</p>
                  }
            </div>
            <div className='row-2 head'>
                <span className='title'>Cover Validity </span>
                <span className='plan-name'>{dateConvert(plan?.plan?.start_date || '')} - {dateConvert(plan?.plan?.expiry_date || '')}</span>
            </div>
            <div className='download-section'>
                <button onClick={() => handleDownload(plan?.plan?.download_certificate || '')} className="pdf-url">Download Certificate</button>
            </div>
            <div className="action-info">
                <PlanActions 
                    assistNo={plan?.plan?.assistance_number || ''} 
                    id={plan?.plan?.subscription_id || 0} 
                    userId={plan?.userId}
                    planData={plan} 
                />
            </div>
        </div>
    </div>
    
  );
};

export default PlanCard;
